<template>
<div>
  <div class="CourseList"
  v-loading="loading"
  element-loading-text="拼命加载中"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.8)"
  v-loading.fullscreen.lock="true">
    <h2>现已开放 <span>{{this.total}}</span> 门课程供您选择</h2>
    <el-select
      v-model='CourseListTemp.course_name'
      filterable
      placeholder='请选择或输入关键字搜索'
      @change="getSpecifiedCourse"
      size="medium"
    >
      <el-option
        v-for='item in CourseList'
        :key='item.id'
        :value='item.id'
        :label='item.course_name'
      >
      </el-option>
    </el-select>
    <!-- <el-image v-for="course in CourseList" :key="course.id" :src="course.course_cover_image" lazy @click="goLessonPage(course.id,course.course_name)"></el-image> -->
    <img v-for="course in CourseListTemp" :key="course.id" v-lazy="course.course_cover_image" @click="goLessonPage(course.id,course.course_name)" />
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        query: '',
        pageNum: 1,
        pageSize: 2,
        token: ''
      },
      CourseForm: {
        course_name: ''
      },
      CourseList: [],
      CourseListTemp: [],
      total: 0,
      loading: false
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getCourseList()
  },
  methods: {
    async getCourseList () {
      this.loading = true
      const { data: res } = await this.$http.get('app/courses/', { params: this.queryInfo })
      this.CourseList = res
      this.total = res.length
      this.CourseListTemp = this.CourseList
      // console.log(this.CourseList)
      // console.log(this.total)
      if (res.total === 0) return this.$notify({ title: '失败', message: '获取课程信息失败!', type: 'error' })
      this.loading = false
      this.$notify({ title: '成功', message: '获取课程信息成功!', type: 'success' })
    },
    goLessonPage (courseId, courseName) {
      // this.$router.push('/lessons')
      // 不能使用params进行传参，因为通过name跳转，不能跳转到子路由,只能通过query传参
      // this.$router.push({ name: '/lessons', params: { course_id: courseId } })
      this.$router.push({ path: '/lessons', query: { course_id: courseId, course_name: courseName } })
    },
    getSpecifiedCourse (value) {
      console.log('getSpecifiedCourse-----', value)
      for (let i = 0; i < this.CourseList.length; i++) {
        if (this.CourseList[i].id === value) {
          console.log('i=', i)
          console.log((this.CourseList[i].course_name))
          this.CourseListTemp = this.CourseList.slice(i, i + 1)
          // this.qzjyList.remove(this.qzjyList[i])
          // this.qzjyList.splice(i, 1)
          // console.log('after:', this.qzjyList)
          // console.log((this.qzjyList.length))
        }
      }
    },
    goback () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.CourseList{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 10px;
    align-items: center;
    >el-image{
      width: 80% !important;
    }
    >h2 span{
      font-size: 50px;
      color: coral;
      font-weight: 600;
    }
    >img{
      padding-top: 15px;
      border-radius: 5px;
      min-width: 240px;
      max-width: 100%;
      cursor: pointer;
    }
  }
  .el-image{
    padding-top: 15px;
    border-radius: 5px;
    cursor: pointer;
  }
</style>
